import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { notificationsSettingsRouter } from './routing/notificationsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { notificationsAccessControl } from './access-control/notificationsAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'notifications',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'notifications-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
  },
  routers: {
    partnerScoped: [notificationsSettingsRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.UserMenuUserManagement,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'Configure notification settings and alert preferences for order, inventory, and system events',
          labelId: 'notificationsDomain.settings.pageTitle',
          route: 'notifications-settings',
          accessControl: notificationsAccessControl,
          positionNavV2: 3,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
